import { render, staticRenderFns } from "./newUploadFileMore.vue?vue&type=template&id=28ff0a1b&scoped=true&"
import script from "./newUploadFileMore.vue?vue&type=script&lang=js&"
export * from "./newUploadFileMore.vue?vue&type=script&lang=js&"
import style0 from "./newUploadFileMore.vue?vue&type=style&index=0&id=28ff0a1b&prod&lang=less&scoped=true&"
import style1 from "./newUploadFileMore.vue?vue&type=style&index=1&id=28ff0a1b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff0a1b",
  null
  
)

export default component.exports